import React from 'react'

declare global {
  interface Window {
    moment: any
  }
}

const OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric', month: 'short', day: 'numeric',
  hour: 'numeric', minute: 'numeric'
};

const Record = ({ recordList }: any) => {
  function handleDetailsClick(e: any) {
    const card = e.currentTarget.closest(".ar__predictions__match")
    const detail = card.querySelector(".ar__predictions__match__score__bottom .ar__predictions__points--maintext")
    if (detail.textContent !== "+0 pts") {
      card.classList.toggle("showDetails")
      let isShow = card.classList.contains("showDetails") ? 'Open results' : 'Close results'
      let action = card.classList.contains("showDetails") ? 'Abrir' : 'Cerrar'

      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': `${isShow}- Historical`,
        'interaction': 'true',
        'component_name': 'Modo_Carrera_Predictions',
        'element_text': action,
      });
    }

  }

  return (
    <div className="ar__predictions__matches record">
      {
        recordList?.map((record: any, index: number) => (
          <div key={`${record.match_date}_${index}`} className="ar__predictions__match ar__predictions__match--finish" data-state="finish" data-win={record.win}>
            <div className="ar__predictions__match__row">
              <div className="ar__predictions__match__box">
                <div className="ar__predictions__match__team">
                  <img src={`${record.team_home_image}`} alt={record.team_home_name} title={record.team_home_name} />
                  <div className="ar__predictions__match__team__name">
                    <p className='smallText opacity'>{record.team_home_name}</p>
                  </div>
                </div>
                <div className="ar__predictions__match__point">
                  <p className='title_2'>
                    {record.goal_home}
                  </p>
                </div>
              </div>
              <div className="ar__predictions__match__score live">
                <div className="ar__predictions__match__score__header">
                  <p className="ar__predictions__match__score__league black_20 opacity">
                    {record.season_name}
                  </p>
                  <p className="ar__predictions__match__score__state black_30">
                    {new Intl.DateTimeFormat('es', OPTIONS).format(new Date(record.match_date))}
                  </p>
                </div>
                <div className="ar__predictions__match__score__scoreboard">
                  <p className='black_20 opacity'>tu predicción</p>
                  <div className="ar__predictions__match__score__scoreboard__row">
                    <span className='subtitleSmall'>
                      {record.home}
                    </span>
                    <p className='black_30 '>
                      vs
                    </p>
                    <span className='subtitleSmall'>
                      {record.away}
                    </span>
                  </div>
                </div>
                <div className="ar__predictions__match__score__bottom" onClick={(e) => {
                  if(!(record.points === "0" || Object.keys(record.resume).length === 0)) handleDetailsClick(e)
                }}>
                  <div className="ar__predictions__points">
                    <p className="black_20">Resultados</p>
                    <p className="ar__predictions__points--maintext">+{record.points} <span>pts</span>
                      {
                        record.points === "0" || Object.keys(record.resume).length === 0
                          ? ""
                          : <svg width="14" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3984 11.8606L2.20282 2.62207" stroke="#fff" strokeWidth="3.69405" strokeLinecap="round" strokeLinejoin="round"></path><path d="M20.6641 2.62207L11.4684 11.8606" stroke="#fff" strokeWidth="3.69405" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                      }
                    </p>
                  </div>
                  {Object.keys(record.resume).length > 0
                    && <div className="ar__predictions__points-details">
                      {Object.entries(record.resume).map(([key, value]: any) => {
                        switch (key) {
                          case 'winner':
                            return <div className="ar__predictions__points-details--winning-team">
                              <p>+{value}</p>
                              <p>Equipo ganador</p>
                            </div>;
                          case 'exactly':
                            return <div className="ar__predictions__points-details--exact-marker">
                              <p>+{value}</p>
                              <p>Marcador exacto</p>
                            </div>;
                          case 'equality':
                            return <div className="ar__predictions__points-details--tie">
                              <p>+{value}</p>
                              <p>Acertar el empate</p>
                            </div>;
                        }
                      })}
                    </div>
                  }
                </div>
              </div>
              <div className="ar__predictions__match__box">
                <div className="ar__predictions__match__team">
                  <img src={`${record.team_away_image}`} alt={record.team_away_name} title={record.team_away_name} />
                  <div className="ar__predictions__match__team__name">
                    <p className='smallText opacity'>{record.team_away_name}</p>
                  </div>
                </div>
                <div className="ar__predictions__match__point">
                  <p className='title_2'>
                    {record.goal_away}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )
        )
      }
    </div>
  )
}
export default Record